import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText.js';

/**
 * Title class.
 */
export default class Content extends withIntersectionObserver(Base, {
  threshold: 1,
}) {
  isVisible = false;
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Content',
  };

  /**
   *
   */
  mounted() {
    this.split = SplitText.create(this.$el, {
      type: 'chars',
      mask: 'chars',
      charsClass: '-translate-x-full',
    });
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   *
   */
  launchAnimation() {
    gsap.set(this.$el, { opacity: 1 });
    gsap.to(this.split.chars, {
      x: 0,
      duration: 0.6,
      ease: 'expo.out',
      stagger: {
        each: 0.05,
      },
      onStart: () => {
        this.$terminate();
      },
    });
  }
}
